import { render, staticRenderFns } from "./libro_free.vue?vue&type=template&id=9122767e"
import script from "./libro_free.vue?vue&type=script&lang=js"
export * from "./libro_free.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports